export default __webpack_public_path__ + "static/media/shieldIcon.315180fc.svg";